/**
 * R2R listing type → top-level category mapping for Edit Listing → Details.
 * Primary match: Sharetribe category `id`. Fallback: category `name` (normalizeCategoryLabel).
 *
 * Canonical Console ids: docs/console-listing-catalog.md
 */

// Canonical Console listing type ids (confirmed June 2026)
export const LISTING_TYPE_LIVE_GOODS = 'live_goods';
export const LISTING_TYPE_DRY_GOODS = 'dry_goods';
export const LISTING_TYPE_TANK_SERVICE = 'tank_service';
export const LISTING_TYPE_REEF_ART_APPAREL = 'reef_art_apparel';

// Canonical Console top-level category ids (confirmed June 2026)
export const CATEGORY_ID_CORAL = 'Coral_livegoods';
export const CATEGORY_ID_FISH = 'Fish_livegoods';
export const CATEGORY_ID_EQUIPMENT = 'equip_drygood';

// Actual Console category IDs (confirmed via debug log, June 2026)
const LIVESTOCK_CATEGORY_IDS = [
  CATEGORY_ID_CORAL,
  CATEGORY_ID_FISH,
  'inverts_livegoods',
  'Plants_macro_livegoods',
  'rock_sub_dry_live',
  'inverts_anemones',
];
const LIVESTOCK_CATEGORY_NAMES = [
  'Coral',
  'Fish',
  'Inverts',
  'Marine Plants',
  'Rock & Substrate',
  'Anemones',
];

const REEF_EQUIPMENT_CATEGORY_IDS = [
  'rock_sub_dry_live',
  CATEGORY_ID_EQUIPMENT,
  'nutrition_drygoods',
];
const REEF_EQUIPMENT_CATEGORY_NAMES = [
  'Rock & Substrate',
  'Equipment & Supplies',
  'Food & Nutrition',
];

const TANK_SERVICES_CATEGORY_IDS = ['services_tank', 'reef_events'];
const TANK_SERVICES_CATEGORY_NAMES = ['Tank Services & Maintenance', 'Reef Events'];

const REEFING_APPAREL_CATEGORY_IDS = ['apparel_drygoods'];
const REEFING_APPAREL_CATEGORY_NAMES = ['Reefing Swag and Apparel'];

/** Canonical listing type id → allowed top-level category ids (Console). */
/** @type {Record<string, string[]>} */
export const BY_LISTING_TYPE_CATEGORY_IDS = {
  // Actual Console IDs (confirmed via pub_listingType URL param, June 2026)
  live_goods: LIVESTOCK_CATEGORY_IDS,
  dry_goods: REEF_EQUIPMENT_CATEGORY_IDS,
  tank_service: TANK_SERVICES_CATEGORY_IDS,
  reef_art_apparel: REEFING_APPAREL_CATEGORY_IDS,
  // Legacy / alias keys kept for backwards compatibility
  livestock: LIVESTOCK_CATEGORY_IDS,
  equipment: REEF_EQUIPMENT_CATEGORY_IDS,
  'reef-equipment-supplies': REEF_EQUIPMENT_CATEGORY_IDS,
  'reef-equipment-and-supplies': REEF_EQUIPMENT_CATEGORY_IDS,
  'tank-services': TANK_SERVICES_CATEGORY_IDS,
  'reefing-art-apparel': REEFING_APPAREL_CATEGORY_IDS,
};

/** Canonical listing type id → allowed category display names (product spec). */
/** @type {Record<string, string[]>} */
export const BY_LISTING_TYPE_CATEGORY_NAMES = {
  live_goods: LIVESTOCK_CATEGORY_NAMES,
  dry_goods: REEF_EQUIPMENT_CATEGORY_NAMES,
  tank_service: TANK_SERVICES_CATEGORY_NAMES,
  reef_art_apparel: REEFING_APPAREL_CATEGORY_NAMES,
  // Legacy aliases
  livestock: LIVESTOCK_CATEGORY_NAMES,
  equipment: REEF_EQUIPMENT_CATEGORY_NAMES,
  'reef-equipment-supplies': REEF_EQUIPMENT_CATEGORY_NAMES,
  'reef-equipment-and-supplies': REEF_EQUIPMENT_CATEGORY_NAMES,
  'tank-services': TANK_SERVICES_CATEGORY_NAMES,
  'reefing-art-apparel': REEFING_APPAREL_CATEGORY_NAMES,
};

/** Normalized Console listing type label → allowed category names. */
/** @type {Record<string, string[]>} */
export const BY_LISTING_TYPE_LABEL = {
  livestock: LIVESTOCK_CATEGORY_NAMES,
  'live goods': LIVESTOCK_CATEGORY_NAMES,
  equipment: REEF_EQUIPMENT_CATEGORY_NAMES,
  'dry goods': REEF_EQUIPMENT_CATEGORY_NAMES,
  'reef equipment and supplies': REEF_EQUIPMENT_CATEGORY_NAMES,
  'tank services': TANK_SERVICES_CATEGORY_NAMES,
  'tank service': TANK_SERVICES_CATEGORY_NAMES,
  'reefing art and apparel': REEFING_APPAREL_CATEGORY_NAMES,
  'reefing art/apparel': REEFING_APPAREL_CATEGORY_NAMES,
  'reef art apparel': REEFING_APPAREL_CATEGORY_NAMES,
};

/** @type {Record<string, string>} */
export const LISTING_TYPE_ID_BY_LABEL = {
  livestock: 'live_goods',
  'live goods': 'live_goods',
  equipment: 'dry_goods',
  'dry goods': 'dry_goods',
  'reef equipment and supplies': 'dry_goods',
  'tank services': 'tank_service',
  'tank service': 'tank_service',
  'reefing art and apparel': 'reef_art_apparel',
  'reefing art/apparel': 'reef_art_apparel',
  'reef art apparel': 'reef_art_apparel',
};
